export const PANEL_ACTION_ICONS = {
  move: 'mdi-arrow-right'
};
